
export enum SurePayTransactionType {
  CheckConnection = 0,
  Purchase = 1,
  Refund = 2
}
